export default "__VITE_ASSET__D1p5nlaY__"